import { IamAuthProvider } from "@itaas/core/auth/IamAuthProvider";
import { billingSessionApi } from "@/auth/billing-auth.service";
import { SUITE_URL } from "@/core/billing/config";

interface BillingAuthProviderProps {
  children: React.ReactNode;
}

export function BillingAuthProvider({ children }: BillingAuthProviderProps) {
  return (
    <IamAuthProvider api={billingSessionApi} moduleId="billing" suiteUrl={SUITE_URL}>
      {children}
    </IamAuthProvider>
  );
}
